export default function Footer() {
  return (
    <>
      <section className="py-20 border-b border-line bg-ground">
        <div className="max-w-6xl mx-auto px-6">
          <div
            className="p-8 border border-dashed border-line-light bg-ground-alt text-center"
            data-testid="testimonials-empty-state"
          >
            <span className="mono-tag text-xs uppercase text-slate-400 tracking-widest block mb-2">
              Collector Testimonials
            </span>
            <h4 className="text-base font-semibold text-white uppercase mb-2">
              Private Collector &amp; Designer Notes
            </h4>
            <p className="text-sm text-slate-400 max-w-md mx-auto">
              Collector impressions and interior installation features from our
              upcoming season will be documented here.
            </p>
          </div>
        </div>
      </section>

      <footer className="py-12 bg-ground-deep text-slate-400 text-xs">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <span className="text-white font-bold uppercase text-sm">THE ABSTRACTS</span>
            <span className="text-slate-600">&middot;</span>
            <span>Original abstract &amp; landscape fine art</span>
          </div>
          <div className="flex gap-6 mono-tag uppercase tracking-wider text-[11px]">
            <a href="#add-piece" className="text-gold hover:underline" data-testid="footer-add-piece-link">
              + Add Pieces
            </a>
            <a href="#gallery" className="hover:text-white" data-testid="footer-catalog-link">
              Shop Catalog
            </a>
            <a href="#commissions" className="hover:text-white" data-testid="footer-commission-link">
              Commission Form
            </a>
          </div>
          <div className="text-slate-400">
            &copy; THE ABSTRACTS. All artwork copyright of the artist.
          </div>
        </div>
      </footer>
    </>
  );
}
